module.exports = __webpack_public_path__ + "static/media/n1.ceba1933.jpg";